import Cookies from "js-cookie";

import { BR_DEFAULT_UID, BR_USERID_KEY } from "~/constants/bloomreach";
import { checkBruidFlag } from "~/utils/data/bloomreach/check-br-uid-flag/check-br-uid-flad";

import { DetailedPageType } from "../bloomreach/types";

export const getBrUid2Client = (
  pageLocale?: string,
  pageType?: DetailedPageType,
) => {
  //NOTE: Delete entire dependency from pageLocale and AzureConfigurator after finishing work with (DIGIX-17933 Re-Integrate br_uid_2 and ref_url)
  const isBloomreachBruid = pageLocale ? checkBruidFlag(pageLocale, pageType) : true;
  const brUid2Cookie = isBloomreachBruid ? Cookies.get(BR_USERID_KEY) : "";

  if (brUid2Cookie) {
    return brUid2Cookie;
  }

  return BR_DEFAULT_UID;
};
